import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { LSProvider } from './Context/useLSContext';
import { AuthProvider } from 'react-oidc-context';
import { DataProvider } from './Context/useDataContext';
import { HoleSettingsProvider } from './Context/useHoleSettingsContext';
import * as serviceWorkerRegistration from './utils/serviceWorkerRegistration';

const localStorageStore = {
  get: (key: string) => {
    const value = localStorage.getItem(key);
    return value ? JSON.parse(value) : null;
  },
  set: (key: string, value: any) => {
    localStorage.setItem(key, JSON.stringify(value));
  },
  remove: (key: string) => {
    localStorage.removeItem(key);
  }
};

const cognitoAuthConfig = {
  authority: process.env.REACT_APP_COGNITO_AUTHORITY,
  client_id: process.env.REACT_APP_COGNITO_CLIENT_ID,
  redirect_uri: `${window.location.origin}/login`,
  response_type: "code",
  scope: "email openid profile",
  userStore: localStorageStore,
  automaticSilentRenew: true,
  loadUserInfo: true,
  onSigninRedirect: (url: string) => {
    localStorage.setItem('redirectURL', window.location.pathname);
  }
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <DataProvider>
    <LSProvider>
      <HoleSettingsProvider>
        <AuthProvider {...cognitoAuthConfig}>
          <App />
        </AuthProvider>
      </HoleSettingsProvider>
    </LSProvider>
  </DataProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Register the service worker for PWA functionality
serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    // When an update is available, you can show a notification to the user
    const updateConfirm = window.confirm(
      'A new version of the application is available! Click OK to update.'
    );
    
    if (updateConfirm) {
      serviceWorkerRegistration.applyUpdate();
    }
  },
});
